import React from 'react';
import './Conversion.css';
import { calculatePercentage } from '../../../utils/analyticsHelpers';

const CONVERSION_STEPS = [
    {
        label: 'View → Booking',
        value: 'bookingStarted',
        base: 'tripViews'
    },
    {
        label: 'Booking → Checkout',
        value: 'checkoutStarted',
        base: 'bookingStarted'
    },
    {
        label: 'Checkout → Payment',
        value: 'paymentInitiated',
        base: 'checkoutStarted'
    },
    {
        label: 'Payment → Success',
        value: 'paymentSuccess',
        base: 'paymentInitiated'
    },
    {
        label: 'Success → Booking',
        value: 'bookingConfirmed',
        base: 'paymentSuccess'
    }
];

const Conversion = ({ tripViews = 0, funnel = {} }) => {
    const overallConversion = calculatePercentage(funnel.paymentSuccess, tripViews);

    return (
        <section className='analyticsSection conversionSection'>
            <div className='analyticsSectionHeader'>
                <div>
                    <h2>Conversion</h2>

                    <span>Funnel conversion rates</span>
                </div>

                <div className='overallConversion'>{overallConversion}%</div>
            </div>

            <div className='conversionList'>
                {CONVERSION_STEPS.map((step) => {
                    const value = step.value === 'tripViews' ? tripViews : funnel[step.value] || 0;

                    const base = step.base === 'tripViews' ? tripViews : funnel[step.base] || 0;

                    const percentage = calculatePercentage(value, base);

                    return (
                        <div className='conversionRow' key={step.label}>
                            <span>{step.label}</span>

                            <div className='conversionBar'>
                                <div
                                    className='conversionBarFill'
                                    style={{
                                        width: `${percentage}%`
                                    }}
                                />
                            </div>

                            <strong>{percentage}%</strong>
                        </div>
                    );
                })}
            </div>
        </section>
    );
};

export default Conversion;
